import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { TimeFilterProvider } from "./context/TimeFilterContext";
import Sidebar from "./components/Sidebar";
import BreadcrumbBar from "./components/BreadcrumbBar";
import Login from "./pages/Login";
import Signup from "./pages/Signup";

// Pages
import Dashboard from "./pages/Dashboard";
import TenantManagement from "./pages/TenantManagement";
import Users from "./pages/Users";
import Plans from "./pages/Plans";
import Executions from "./pages/Executions";
import Modules from "./pages/Modules";
import Audit from "./pages/Audit";
import Health from "./pages/Health";
import Integrations from "./pages/Integrations";
import Security from "./pages/Security";
import Support from "./pages/Support";
import BillingAndSubscription from './pages/BillingAndSubscriptions.js';
import OperationalAnalytics from "./pages/OperationalAnalytics";

import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/" replace />; // Redirect to root (Login) if not authenticated
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="app-wrapper">
      <Sidebar collapsed={collapsed} toggleFormatted={() => setCollapsed(!collapsed)} />
      <div className={`main-wrapper ${collapsed ? "sidebar-collapsed" : ""}`}>
        <main className="main-content">
          <div className="container-fluid">
            <BreadcrumbBar />
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/tenants" element={<TenantManagement />} />
              <Route path="/users" element={<Users />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/executions" element={<Executions />} />
              <Route path="/billing" element={<BillingAndSubscription />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/analytics" element={<OperationalAnalytics />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/health" element={<Health />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/security" element={<Security />} />
              <Route path="/support" element={<Support />} />
              <Route path="*" element={<div className="p-5">Page Not Found</div>} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <TimeFilterProvider>
        <Routes>
          <Route path="/" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/signup" element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          } />
          <Route path="/*" element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          } />
        </Routes>
      </TimeFilterProvider>
    </AuthProvider>
  );
}

export default App;
